import React from 'react';
import { StatCard } from './StatCard';
import { DuoClockEightIcon } from '../../theme/Icons';
import { IPeriodData } from '../model/IPeriodData';
import { IPersonalTime, PERSONAL_TIME_LABELS } from '../model/ICheckin';
import { ChangeIndicator } from './ChangeIndicator';

export const PersonalTimeStatCard: React.FC<{selectedPeriod: IPeriodData, priorPeriod: IPeriodData}> = ({ selectedPeriod, priorPeriod }) => {

    const getMode = ((period: IPeriodData): IPersonalTime | undefined => {
        // create a map of IPersonalTime (1|2|3|4) to count, e.g. { 1: 3, 2: 5, 3: 1, 4: 2 }
        const counts: {[time in IPersonalTime]?: number} = {};
        for (const c of period.personal) {
            if (c.personalTime) {
                counts[c.personalTime] = (counts[c.personalTime] || 0) + 1;
            }
        }

        // pivot map into array, e.g. [ { time: 1, count: 3 }], sorted by count, high to low
        const arr = ((Object.keys(counts) as unknown as IPersonalTime[])
            .map(time => ({ time, count: counts[time] }))
            .sort((i1, i2) => (i2.count! - i1.count!) || (i2.time - i1.time)));

        // take first (highest) count
        return arr[0]?.time;
    });

    const mode = getMode(selectedPeriod) || 0;
    const priorMode = getMode(priorPeriod) || 0;

    const trendDir = mode > priorMode ? 'up' : mode < priorMode ? 'down' : 'flat';
    const trendColor = trendDir === 'up' ? 'theme-dark-green' : trendDir === 'down' ? 'theme-red' : undefined;

    return (
        <StatCard
            data-id="personal-time-card"
            Icon={DuoClockEightIcon}
            iconColor="theme-teal"
            description="personal time per day"
            value={mode ? PERSONAL_TIME_LABELS[mode] : '—'}
            changeIndicator={Boolean(mode && priorMode) &&
                <ChangeIndicator direction={trendDir} color={trendColor} />
            }
        />
    );
};
